/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Keys_Perm_EmployeesInputs */

const vi_api_keys_perm_employees = /** @type {(inputs: Api_Keys_Perm_EmployeesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhân viên`)
};

/**

* @param {Api_Keys_Perm_EmployeesInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const api_keys_perm_employees = /** @type {((inputs?: Api_Keys_Perm_EmployeesInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Keys_Perm_EmployeesInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_api_keys_perm_employees(inputs)
});